<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <x-y-chart
        v-for="data in dataList"
        :key="data.id"
        :data-config="data"
        :unit-prop="unitProp"
        :chart-type="chartType"
        :stack-type="stackType"
        :download-name="downloadName"
        chart-min-height="400px"
        chart-height="auto"
        style="flex:1 0 100%;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'StatisticalAnalysisPM25OCEC',
  routeInfo: {
    label: 'PM2.5与OC和EC',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, XYChart},
  data: () => ({
    query: {
      factorIds: [],
      isMultipleIntegral: true
    },
    chartType: 'bar',
    stackType: 1
  }),
  computed: {
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1008')),
      new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId !== '6404'))
    ],
    downloadName: () => 'PM2.5与OC和EC'
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let siteId = dimensionIds[dimension]
      let factorId = dimensionIds[dimension ^ 1]

      if (factorId === '1008') {
        return {
          type: 'line',
          showSymbol: false
        }
      } else {
        let param = {
          stack: siteId,
          barMaxWidth: 30,
          showSymbol: false,
          areaStyle: {}
        }

        Object.defineProperty(param, 'type', {
          get: () => this.chartType,
          enumerable: true
        })

        return param
      }
    },
    getSelectedNames (dimension, params) {
      return dimension === 0 ? Object.values(params[dimension ^ 1]).reduce((map, config) => {
        map[config.name] = /^1008|640(0|1|4)$/.test(config.id)

        return map
      }, {}) : null
    }
  },
  watch: {
    filterFactorMap: {
      immediate: true,
      handler (filterFactorMap) {
        this.selectedNames = this.query.factorIds.reduce((list, factorId) => {
          if (/^1008|640(0|1|4)$/.test(factorId)) {
            let factor = filterFactorMap[factorId]

            if (factor) {
              list.push(factor.name)
            }
          }

          return list
        }, [])
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/00PM/04PM25-OCEC/index.vue